import { render, staticRenderFns } from "./OrderQuittingModal.vue?vue&type=template&id=5b4b8508&scoped=true&"
import script from "./OrderQuittingModal.vue?vue&type=script&lang=js&"
export * from "./OrderQuittingModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderQuittingModal.vue?vue&type=style&index=0&id=5b4b8508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4b8508",
  null
  
)

export default component.exports